
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { HeadMeta } from '@/components/Molecules/HeadMeta/HeadMeta';
import type { ISeriesItemProps } from '@/components/Pages/Series/SeriesViewPage';
import { SeriesViewPage } from '@/components/Pages/Series/SeriesViewPage';
import { BaseAppContextContainer } from '@/contexts/AppContext/AppContextContainer';
import { getAppContextServerSideProps } from '@/contexts/AppContext/AppContextServer';
import { ContentType } from '@/interfaces';
import type { IBaseAnalyticsData } from '@/services/Analytics/bnefAnalyticsInterfaces';
import { TrackedProductTypes } from '@/services/Analytics/bnefAnalyticsSettings';
const getInitialAnalyticsMetadata = (seriesId: string): IBaseAnalyticsData => ({
    page: {
        pageInfo: {
            pageName: 'BNEF: Series: Details',
        },
        category: {
            siteSection: 'BNEF: Series',
        },
        content: {
            type: TrackedProductTypes.Series,
            id: `${TrackedProductTypes.Series}-${seriesId}`,
        },
    },
});
const getServerSideProps = getAppContextServerSideProps(async ({ query, api }) => {
    const data = await api.get({
        path: '/series/[ID]/insights',
        replacements: { id: query.series as string },
    });
    if (data !== null) {
        return {
            props: {
                analyticsMetadata: getInitialAnalyticsMetadata(query.series as string),
                ...data,
            },
        };
    }
    return { notFound: true };
}, async ({ query, res, api }) => {
    const data = await api.get({
        path: '/public/series/[ID]',
        replacements: { id: query.series as string },
    });
    if (data !== null) {
        const series = data?.series;
        return {
            props: {
                type: ContentType.series,
                title: series.title,
                description: series.summary,
                image: series.image,
                tags: series.tags,
            },
        };
    }
    res.statusCode = 404;
});
export default class extends BaseAppContextContainer<ISeriesItemProps> {
    public render() {
        const { series } = this.props;
        return (<>
                <HeadMeta title={series.title} type={ContentType.series} description={series.description} image={series.leadImage?.baseUrl} tags={series.tags}/>
                <SeriesViewPage {...this.props}/>
            </>);
    }
}

    async function __Next_Translate__getServerSideProps__1a1a25d1e9e__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/series/[series]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a25d1e9e__ as getServerSideProps }
  